import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'
import { ColumnVersion } from '../types'

const FIVE_MINUTES = 1000 * 60 * 5

interface ColumnVersionsResponse {
    versions: ColumnVersion[]
    total: number
}

export const useGetTPPColumnVersionsQuery = (columnId: string | null) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getColumnVersions = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const url = `/api/tpps/columns/${columnId}/versions`

            const response = await callAPI(url, 'get', token)

            return response.data as ColumnVersionsResponse
        } catch (e) {
            console.log(e)
            throw e
        }
    }

    return useQuery<ColumnVersionsResponse>(['tppColumnVersions', columnId], getColumnVersions, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!columnId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        refetchOnWindowFocus: false,
        retry: 3,
    })
}
